import { createRouter, createWebHistory } from "vue-router";
// import Home from '../views/Home.vue'
// import Main from "../views/Main.vue";
import MultistepMain from "../views/MultistepMain.vue";
import MainLoadingStyle from "../views/MainLoadingStyle.vue";
import Vlog from "../views/Vlog.vue";
import VlogHome from "@/components/vlog/containers/VlogHome.vue";
import VlogPlay from "@/components/vlog/containers/VlogVideoDetail.vue";
import VlogDetail from "@/components/vlog/containers/VlogDetail.vue";
import VlogSearchResults from "@/components/vlog/containers/VlogSearchResults.vue";
// import VlogEmpty from "@/components/vlog/containers/VlogEmpty.vue";
import store from "@/store/index.js";

const routes = [
	{
		path: "/home",
		name: "MainLoadingStyle",
		component: MainLoadingStyle,
	},
	{
		path: "/",
		name: "MultistepMain",
		component: MultistepMain,
	},
	{
		path: "/vlog",
		name: "Vlog",
		component: Vlog,
		// https://router.vuejs.org/zh/guide/essentials/nested-routes.html
		children: [
			{
				// 首页
				path: "",
				component: VlogHome,
			},
			{
				// 带分类id
				path: "t/:tabid",
				component: VlogHome,
				props: (route) => ({ initialTabID: route.tabid }),
			},
			// {
			// 	//
			// 	path: "video/:id",
			// 	component: VlogPlay,
			// 	props: route => ({ id: route.id}),
			// },
			{
				// 再多一级来处理，这样VlogPlay这一级就可以非复用组件形式
				path: "video",
				component: VlogDetail,
				children: [
					{
						// 带分类id
						path: ":id",
						component: VlogPlay,
						props: (route) => ({ id: route.id }),
					},
					// 不合法路径则返回到首页
				],
			},
			{
				// 搜索结果页，带keywords
				path: "search",
				component: VlogSearchResults,
				props: (route) => ({ query: route.query.keywords }),
			},
		],
	},
	// {
	//   path: '/home',
	//   name: 'Home',
	//   component: Home
	// },
	// {
	//   path: '/about',
	//   name: 'About',
	//   // route level code-splitting
	//   // this generates a separate chunk (about.[hash].js) for this route
	//   // which is lazy-loaded when the route is visited.
	//   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	// }
];

// 运行时探测路由 base：
// - 访问路径以 /g 开头时，认为部署在 /g 子路径（未绑定独立域名）
// - 否则认为已绑定独立域名，base 使用 /
function detectBase() {
	if (typeof window !== "undefined" && window.location.pathname.startsWith("/g")) {
		return "/g";
	}
	return "/";
}

const ROUTER_BASE = detectBase();

const router = createRouter({
	history: createWebHistory(ROUTER_BASE),
	routes,
});

router.beforeEach((to, from) => {
	from;
	// console.log(to);

	if (to.matched?.length == 0) {
		// fallback
		if (to.fullPath?.startsWith("/vlog")) {
			return { path: "/vlog" };
		}
		// 原逻辑：未匹配路径统一跳转到首页，导致访问 /g2 时被重定向到 /g
		// else {
		// 	return { path: "/" };
		// }
		// 修改后：非 /vlog 的未匹配路径不再继续导航，避免 Vue Router 在初始化时
		// 把 /g2 解析为 base(/g) + path(2)，再规范化成 /g/2 导致地址栏跳转。
		// 返回 false 会取消本次导航，地址栏保持原 URL（如 /g2）。
		return false;
	}
	return true;
});

router.afterEach((to, from) => {
	// console.log(to);

	if (to.fullPath != from.fullPath) {
		// console.log("sendToAnalytics: " + to.fullPath);
		sendToAnalytics(to, from);
	}
});

function sendToAnalytics(to, from) {
	to;
	// cleanup already added
	document
		.querySelectorAll("body > img[src^='https://wei.ltd.com/analyst']")
		.forEach(function(x) {
			x.remove();
		});

	// const route = router.resolve(to);
	// const absoluteURL = new URL(route.href, window.location.origin).href;
	// console.log(absoluteURL);
	// console.log(window._ga);
	// console.log(store.state.websiteId);

	const websiteId = store.state.websiteId;
	const fromURL = from.href?.length == 0 ? "" : new URL(from.href, window.location.origin).href;
	const toURL = to.href?.length == 0 ? "" : new URL(to.href, window.location.origin).href;
	// console.log(fromURL);
	// console.log(toURL);
// console.log(websiteId);
	if (
		websiteId > 0 &&
		(!(process.env.NODE_ENV == "development") || websiteId == 394210)
	) {
		// if (websiteId > 0) {
		const _ga = window._ga;

		// console.log(from);
		// console.log(to);
		
		// _ga.params.r = document.referrer;
		// _ga.params.h = window.location.href;
		_ga.params["r"] = fromURL;
		_ga.params["h"] = toURL;
		_ga.url = "https://wei.ltd.com/analyst";
		_ga.params["wi"] = "3";
		_ga.params["ui"] = "0";
		_ga.init(websiteId);
	}
}

export default router;
